import React from "react";

import SkeletonAnimation from "../Skeleton/BasicSkeleton/SkeletonAnimation";
import SkeletonElement from "../Skeleton/BasicSkeleton/SkeletonElement";
import SkeletonCard from "../Skeleton/BasicSkeleton/SkeletonCard";

const LeaderBoardPopularSkeleton = () => {
  return (
    <div className="leader-board-skeleton">
      <div className="Leaderboard-hero leaderboard-popular mx-auto">
        <div className="gangsta-card-container p-4">
          <SkeletonCard className="m-0" />
          <SkeletonCard className="m-0" />
          <SkeletonCard className="m-0" />
          <SkeletonCard className="m-0" />
          <SkeletonCard className="m-0 d-none d-md-block" />
          <SkeletonCard className="m-0 d-none d-md-block" />
          <SkeletonCard className="m-0 d-none d-md-block" />
        </div>
      </div>
    </div>
  );
};

export default LeaderBoardPopularSkeleton;
